export default __webpack_public_path__ + "static/screenThirdSectionRu-5eaeba61a1027486c753f154b45d4f40.webp";